// Per document-service types:
// https://github.com/Audibene-GMBH/cf.document-service/blob/374e8b135dac737bc11d60c18c0de9670255158c/internal/domain/model/type.go#L14-L52
const DocumentType = {
  AUDIOGRAM: 'AUDIOGRAM',
  COPAYMENT_EXEMPTION: 'COPAYMENT_EXEMPTION',
  DATA_PRIVACY_AGREEMENT: 'DATA_PRIVACY_AGREEMENT',
  DECLARATION_ADDITIONAL_COSTS: 'DECLARATION_ADDITIONAL_COSTS',
  DECLARATION_OF_ACCEPTANCE_OF_OBLIGATIONS: 'DECLARATION_OF_ACCEPTANCE_OF_OBLIGATIONS',
  DECLARATION_OF_DAMAGE: 'DECLARATION_OF_DAMAGE',
  DECLARATION_OF_LOSS: 'DECLARATION_OF_LOSS',
  DELIVERY_NOTE: 'DELIVERY_NOTE',
  DELIVERY_RECEIPT: 'DELIVERY_RECEIPT',
  DEVICE_INSURANCE_INVOICE: 'DEVICE_INSURANCE_INVOICE',
  DEVICE_INSURANCE_OFFER: 'DEVICE_INSURANCE_OFFER',
  DEVICE_INSURANCE_POLICY: 'DEVICE_INSURANCE_POLICY',
  DEVICE_INSURANCE_PURCHASE_AGREEMENT: 'DEVICE_INSURANCE_PURCHASE_AGREEMENT',
  DIRECT_DEBIT_MANDATE: 'DIRECT_DEBIT_MANDATE',
  ENT_PRESCRIPTION: 'ENT_PRESCRIPTION',
  FITTING_REPORT: 'FITTING_REPORT',
  HEARING_PROMISE: 'HEARING_PROMISE',
  INSTALLMENT_PLAN: 'INSTALLMENT_PLAN',
  INVOICE: 'INVOICE',
  MEDICAL_WAIVER: 'MEDICAL_WAIVER',
  OTHER: 'OTHER',
  PATIENT_INFORMATION: 'PATIENT_INFORMATION',
  PAYMENT_PLAN: 'PAYMENT_PLAN',
  PRESCRIPTION: 'PRESCRIPTION',
  PRICE_INFORMATION: 'PRICE_INFORMATION',
  PURCHASE_DELIVERY_RECEIPT: 'PURCHASE_DELIVERY_RECEIPT',
  QUOTE: 'QUOTE',
  RELEASE_FROM_CONFIDENTIALITY: 'RELEASE_FROM_CONFIDENTIALITY',
  SALES_CREDIT_MEMO: 'SALES_CREDIT_MEMO',
  SALES_INVOICE: 'SALES_INVOICE',
  SALES_OFFER: 'SALES_OFFER',
  TESTING_SHEET: 'TESTING_SHEET',
  TREATMENT_COVERAGE_NOTIFICATION: 'TREATMENT_COVERAGE_NOTIFICATION',
  TREATMENT_COVERAGE_NOTIFICATION_RESPONSE: 'TREATMENT_COVERAGE_NOTIFICATION_RESPONSE',
  TRIAL_AGREEMENT: 'TRIAL_AGREEMENT',
  TRIAL_INSURANCE: 'TRIAL_INSURANCE',
  UNKNOWN: 'UNKNOWN',
} as const

type DocumentType = typeof DocumentType[keyof typeof DocumentType]

type RequiredDocument = {
  gid: string
  country: string
  customerGid: string
  documentGid: string | null
  documentType: DocumentType
  language: string
  mustBeSigned: boolean
  requiredDocumentDefinitionGid: string
  createdAt: string
  isDeleted: boolean
}

type SigningDefinition = {
  gid: string
  country: string
  // IMPORTANT: `documentType` is a string type in the document signing service,
  // but we know its values should be a valid DocumentType from the document service
  // for document signing to work in concert with the document service so we type it as `DocumentType`
  // See for details: https://github.com/Audibene-GMBH/cf.document-signing-service/blob/d6658d77c648b6bb770738b4d913ce41a29d97ab/src/domain/models/signature/signing-definition.ts#L224
  documentType: DocumentType
  deliveryModel?: string | null
  solution?: string | null
  isDeleted: boolean
}

const SigningRequestStatus = {
  CANCELED: 'CANCELED',
  COMPLETED: 'COMPLETED',
  CREATED: 'CREATED',
  IN_PROGRESS: 'IN_PROGRESS',
  PARTIALLY_COMPLETED: 'PARTIALLY_COMPLETED',
} as const

type SigningRequestStatus = typeof SigningRequestStatus[keyof typeof SigningRequestStatus]

type SigningRequest = {
  gid: string
  country: string
  documentGid: string
  signingDefinitionGid: string
  status: SigningRequestStatus
}

export { DocumentType }
export type { RequiredDocument, SigningDefinition, SigningRequest }
